import React from 'react';
import { IconType } from 'react-icons';

interface IconProps {
  as: IconType;
  [key: string]: any; // للسماح بتمرير أي props
}

const Icon: React.FC<IconProps> = ({ as, ...restProps }) => {
  // 1. نقوم بعمل Type Assertion لـ 'as' إلى 'any' ثم إلى 'React.ElementType'.
  //    هذا يخبر TypeScript بشكل قسري أن 'as' هو مكون صالح للعرض.
  const IconComponent = as as any as React.ElementType;

  // 2. الآن يمكن استخدامه كمكون JSX بدون أخطاء.
  return <IconComponent {...restProps} />;
};

export default Icon;
